// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'cloud';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M13.813 14.25a3.7 3.7 0 0 0 2.969-1.486 3.644 3.644 0 0 0 .552-3.256 3.651 3.651 0 0 0-.872-1.46 3.703 3.703 0 0 0-4.735-.462 5.611 5.611 0 0 0-1.429-2.802A5.67 5.67 0 0 0 7.58 3.179c-1.041-.267-2.138-.235-3.161.094s-1.931.94-2.617 1.763S.68 6.86.545 7.92a5.592 5.592 0 0 0 .495 3.103 5.636 5.636 0 0 0 2.092 2.355 5.69 5.69 0 0 0 3.038.873z'
  />
);

export const viewBox = '0 0 18 18';
